import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { signUp } from 'aws-amplify/auth';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Container, Form, InputGroup, Modal } from 'react-bootstrap';
import CustomModal from '../../../components/Modals/CustomModal';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { IoEye, IoEyeOff } from "react-icons/io5";
import Select from 'react-dropdown-select';

const CreateMANAGER = async (name: string, email: string, password: string, type: string) => {
  try {
    console.log("POST", email);
    const response = await axios.post("/api/create/manager", {
      name,
      email,
      password,
      type,
    });

    console.log("Create MANAGER:", response.data);
    return response.data; // return client token
  } catch (error) {
    console.error("Erreur lors de la création du SQL user :", error);
    return null;
  }
};

const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

const PASSWORD_REGEX = 
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9])/

const USERNAME_REGEX = /^[a-zA-Z0-9_-]+(?: [a-zA-Z0-9_-]+)*$/; // alphanumeric and underscore

type SignUpData = {
  name: string;
  email: string;
  username: string;
  type: string;
  password: string;
  passwordRepeat: string;
  acceptedTerms: boolean;
};

const SignUpScreen = () => {
  // I18N
  const { t } = useTranslation();
  // MODAL
  const [contentModal, setContentModal] = useState(null);
  const [linkModal, setLinkModal] = useState(null);
  const [showCustomModal, setShowCustomModal] = useState(false);
  const [footerModal, setFooterModal] = useState(true);
  // VALIDATION
  const [passwordHidden, setPaswordHidden] = useState(true);
  const [passwordRepeatHidden, setPaswordRepeatHidden] = useState(true);
  const [loading, setLoading] = useState(false);
  const {register, control, handleSubmit, watch, reset, formState: { errors }} = useForm<SignUpData>();
  // const pwd = watch('password');
  const navigate = useNavigate();

  useEffect(() => {
    document.title = t('title.signup');
  }, []);

  const onRegisterPressed = async ({name, email, username, type, password, passwordRepeat, acceptedTerms}: SignUpData) => {
    if (loading) {
      return;
    };
    if (password != passwordRepeat) {
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t('signup.password_error_title')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('signup.password_error_message')}</p>
        </Modal.Body></>);
      setShowCustomModal(true);
      return;
    };
    if (!type || (type != "EMPLOYEE" && type != "MANAGER")) {
      setContentModal(<>
        <Modal.Header closeButton>
          <Modal.Title>{t('signup.type_title')}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>{t('signup.type_message')}</p>
        </Modal.Body></>);
      setShowCustomModal(true);
      return;
    };
    setLoading(true);
    
    try {
      const { isSignUpComplete, userId, nextStep } = await signUp({
        username: username, // username == email
        password,
        options: {
          userAttributes: {
            email: username,
            name,
            username: username,
          },
          // optional
          autoSignIn: true
        }
      });
      const SQLUser = await CreateMANAGER(name, username, password, type);
      console.log("SQL", SQLUser)

      setFooterModal(false);
      setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('signup.account_create_title')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{t('signup.account_create_message')}</p>
            </Modal.Body>
            
            <Modal.Footer>
                <Button variant="secondary" onClick={() => {setShowCustomModal(false); setFooterModal(true); navigate('/confirmEmail', { state: { status: "bg-success", title: t('toast.confirmEmailTitle'), toastMessage: t('toast.confirmEmail') }});}}>
                  {t('punch.close')}
                </Button>
            </Modal.Footer>
            </>
            
          );
      setShowCustomModal(true);
    } catch (error) {
      console.log('Registration Error : ', error);
      setContentModal(<><Modal.Header closeButton>
        <Modal.Title>{t('signup.registration_error')}</Modal.Title>
            </Modal.Header>
      
            <Modal.Body>
              <p>{(error as Error).message}.</p>
            </Modal.Body></>);
      setShowCustomModal(true);
    } finally {
      setLoading(false);
      reset();
    };
  };

  const onSignInPress = () => {
    navigate('/');
  };

  const goToConfirm = () => {
    navigate('/confirmEmail', { state: { status: "bg-success", title: t('toast.confirmEmailTitle'), toastMessage: t('toast.confirmEmail') }});
  };

  const onTermsOfUsePressed = async () => {
    window.open('https://schedulum.org/terms_of_use', '_blank');
    // const url = 'https://schedulum.org/terms_of_use';
    // navigate('/terms_of_use')
    // const url = 'https://schedulum.org/terms.html';
    // useBrowser(url);
  };

  const onPrivacyPressed = async () => {
    window.open('https://www.termsfeed.com/live/7c0fa198-cc6a-41a1-8c7a-ae823ac68a14', '_blank');
    // const url = 'https://www.termsfeed.com/live/7c0fa198-cc6a-41a1-8c7a-ae823ac68a14';
    // useBrowser(url);
  };

  // const onTermsOfUsePressed = () => {
  //   console.warn('onTermsOfUsePressed');
  // };

  // const onPrivacyPressed = () => {
  //   console.warn('onPrivacyPressed');
  // };

  return (
    <>
      <CustomModal
        show={showCustomModal}
        onHide={() => setShowCustomModal(false)}
        link={linkModal}
        children={contentModal}
        isFooter={footerModal}
        // animation={true}
      />
      <Form className="register-form">
        <h2 className="text-center">{t('signup.register_form')}</h2>
        <Container className="">
          <InputGroup>
            <Form.Control
              placeholder={t('signup.name')}
              aria-label="Name"
              // aria-describedby="basic-addon1"
              className={`me-lg-2 ${errors.name ? 'is-invalid' : ''}`} 
              {...register("name", {
                required: t("signup.username_required"),
                pattern: {
                  value: USERNAME_REGEX,
                  message: t("signup.username_invalid")
                }
              })}
              name="name"
            />
          </InputGroup>
          {errors.name && (
            <p className="text-danger mt-1">{errors?.name?.message}</p>
          )}
          <InputGroup>
            <Form.Control
              placeholder={t('signup.email')}
              aria-label="Username"
              aria-describedby="basic-addon1"
              className={`d-inline me-lg-2 ${errors.passwordRepeat ? 'is-invalid' : ''}`} 
              {...register("username", {
                required: t("signup.email_required"),
                pattern: {
                  value: EMAIL_REGEX,
                  message: t("signup.email_invalid")
                }
              })}
              name="username"
            />
          </InputGroup>
          {errors.username && (
            <p className="text-danger mt-1">{errors?.username?.message}</p>
          )}
          <InputGroup>
            <Form.Select
              aria-label="Type de compte"
              className={`d-inline me-lg-2 ${errors.passwordRepeat ? 'is-invalid' : ''}`} 
              {...register("type", {
                required: t("signup.type_required"),
                validate: (value) =>
                  value === "EMPLOYEE" || value === "MANAGER" || t("signup.type_invalid")
              })}
              name="type"
            >
              <option value="">{t('shift.select')}</option>
              <option value="EMPLOYEE">Employee</option>
              <option value="MANAGER">Manager</option>
            </Form.Select>
          </InputGroup>
          {errors.passwordRepeat && (
            <p className="text-danger mt-1">{errors?.type?.message}</p>
          )}
          <div style={{position: 'relative'}}>
            <InputGroup>
              <Form.Control
                type={passwordHidden ? "password" : "text"}
                placeholder={t('signup.password')}
                className={`me-lg-2 ${errors.password ? 'is-invalid' : ''}`}  
                {...register("password", {
                  required: t("signup.password_required"),
                  minLength: {
                    value: 8,
                    message: t("signup.password_min")
                  },
                  pattern: {
                    value: PASSWORD_REGEX,
                    message: t("signup.password_complexity")
                  }
                })}
                name="password"
              />
            </InputGroup>
            { passwordHidden ?
              <IoEye onClick={() => setPaswordHidden(false)} name="eye" size={30} color="#000" className="password-eye" style={errors.password && {backgroundColor: "#FFF"}}/>
            : 
              <IoEyeOff onClick={() => setPaswordHidden(true)} name="eye-slash" size={30} color="#000" className="password-eye" style={errors.password && {backgroundColor: "#FFF"}} />
            }
          </div>
          {errors.passwordRepeat && (
            <p className="text-danger mt-1">{errors?.password?.message}</p>
          )}
          <div style={{position: 'relative'}}>
            <InputGroup>
              <Form.Control
                type={passwordRepeatHidden ? "password" : "text"}
                placeholder={t('signup.repeat_password')}
                className={`me-lg-2 ${errors.passwordRepeat ? 'is-invalid' : ''}`}  
                {...register("passwordRepeat", {
                  required: t("signup.password_repeat_required"),
                  validate: (value) => value === watch("password") || t("signup.password_mismatch")
                })}
                name="passwordRepeat"
              />
            </InputGroup>
            { passwordRepeatHidden ?
              <IoEye onClick={() => setPaswordRepeatHidden(false)} name="eye" size={30} color="#000" className="password-eye" style={errors.passwordRepeat && {backgroundColor: "#FFF"}} />
            : 
              <IoEyeOff onClick={() => setPaswordRepeatHidden(true)} name="eye-slash" size={30} color="#000" className="password-eye" style={errors.passwordRepeat && {backgroundColor: "#FFF"}} />
            }
          </div>
          {errors.passwordRepeat && (
            <p className="text-danger mt-1">{errors?.passwordRepeat?.message}</p>
          )}
          <Form.Group controlId="formBasicCheckbox" className="my-3">
            <Form.Check 
              type="checkbox"
              label={
                <>
                  {t('signup.agree_to')}{' '}
                  <a href="#" onClick={onTermsOfUsePressed}>{t('signup.terms_of_use')}</a>{' '}
                  {t('signup.and')}{' '}
                  <a href="#" onClick={onPrivacyPressed}>{t('signup.privacy_policy')}</a>
                </>
              }
              {...register("acceptedTerms", {
                required: t("signup.accepted_terms_required")
              })}
            />
          </Form.Group>
          {errors.acceptedTerms && (
            <p className="text-danger mt-1">{errors?.acceptedTerms?.message}</p>
          )}
          <InputGroup>
            <Button type="submit" onClick={handleSubmit(onRegisterPressed)} disabled={loading || !watch("acceptedTerms")}>{loading ? t('signup.loading') : t('signup.register')}</Button>
          </InputGroup>
          <InputGroup>
            <Link to="/confirmEmail">{t('signup.confirmEmailLink')}</Link>
          </InputGroup>
        </Container>
      </Form>
    </>
  );
};

export default SignUpScreen;
